import React from "react"
import { StaticQuery, graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import ArticleCollection from "../components/article-collection"
import { useMetaCollectionConventions } from "../meta/collection/conventions"

const ConventionsPage = () => {
  const description = useMetaCollectionConventions().plain

  return (
    <Layout>
      <SEO title="Conventions" description={description} />

      <StaticQuery
        query={graphql`
          query Conventions {
            conventions: allMarkdownRemark(
              filter: { fields: { contentKind: { eq: "convention" } } }
              sort: { fields: frontmatter___title, order: ASC }
            ) {
              ...ArticleCollectionFragment
            }
          }
        `}
        render={data => (
          <ArticleCollection
            articleTypePath="/conventions"
            articles={data.conventions}
          />
        )}
      />
    </Layout>
  )
}

export default ConventionsPage
